import type { IWorkJourneyManagementUser } from '@src/models/interfaces/workJourneyManagement.interface';
import {
  formatAttendanceIdentifierDisplay,
  nationalIdSearchToken,
} from '@src/packages/utils/nationalId';

import { formatCoverUserDisplayName } from '../formatCoverUserDisplayName';

export const normalizeCoverUserSearchQuery = (value: string): string => value.trim().toLowerCase();

const stripIdentifierPunctuation = (value: string): string =>
  value.replace(/[.\-\s]/g, '').toLowerCase();

/**
 * Case-insensitive match on name / email / journey, plus punctuation-tolerant
 * id-card matching (raw value, formatted display, and national-id search token).
 */
export const matchesCoverUserSearch = (
  user: IWorkJourneyManagementUser,
  query: string,
  organizationCountry?: string | null,
): boolean => {
  if (!query) return true;

  const formattedId = formatAttendanceIdentifierDisplay(organizationCountry, user);
  const idSearchToken = nationalIdSearchToken(organizationCountry, user.idCard || '');
  const haystack = [
    formatCoverUserDisplayName(user),
    user.displayName,
    user.firstName,
    user.lastName,
    user.idCard,
    formattedId,
    idSearchToken,
    user.email,
    user.journeyName,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  if (haystack.includes(query)) {
    return true;
  }

  const queryToken =
    nationalIdSearchToken(organizationCountry, query) || stripIdentifierPunctuation(query);
  if (!queryToken) {
    return false;
  }

  return stripIdentifierPunctuation(haystack).includes(stripIdentifierPunctuation(queryToken));
};
